var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61704 9.70509C8.35054 9.24559 8.91463 8.55991 9.22413 7.75159C9.53362 6.94326 9.57172 6.05619 9.33267 5.22431C9.09362 4.39243 8.5904 3.66091 7.899 3.14021C7.20759 2.6195 6.36555 2.33789 5.5 2.33789C4.63445 2.33789 3.79241 2.6195 3.101 3.14021C2.4096 3.66091 1.90638 4.39243 1.66733 5.22431C1.42828 6.05619 1.46638 6.94326 1.77587 7.75159C2.08537 8.55991 2.64946 9.24559 3.38296 9.70509C2.10403 10.1033 0.967584 10.863 0.110638 11.8925C0.0523928 11.9602 0.0152465 12.0435 0.00378318 12.1321C-0.00768016 12.2207 0.00704101 12.3107 0.0461302 12.391C0.0832387 12.4717 0.142771 12.54 0.217633 12.5879C0.292495 12.6357 0.37953 12.661 0.468365 12.6607H10.5316C10.6205 12.661 10.7075 12.6357 10.7824 12.5879C10.8572 12.54 10.9168 12.4717 10.9539 12.391C10.993 12.3107 11.0077 12.2207 10.9962 12.1321C10.9848 12.0435 10.9476 11.9602 10.8894 11.8925C10.0324 10.863 8.89597 10.1033 7.61704 9.70509Z",
    fill: "#CBA67A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.55655H13.88L13.88 6.43652L13.1205 6.43652L13.1205 8.55655H11V9.31604H13.12V11.4361L13.8795 11.4361V9.31604H16V8.55655Z",
    fill: "#CBA67A",
    stroke: "#CBA67A",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowIcon);
export default __webpack_public_path__ + "static/media/follow-icon.10cbf754302a4be21452cf0652a82d6c.svg";
export { ForwardRef as ReactComponent };